import { render, staticRenderFns } from "./CaixaDeAnexo.vue?vue&type=template&id=ae607918"
import script from "./CaixaDeAnexo.vue?vue&type=script&lang=js"
export * from "./CaixaDeAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports